export const STATUS_LIST = {
    '0': {
        'text': 'To do',
        'class': 'bg-danger'
    },
    '1': {
        'text': 'In review',
        'class': 'bg-warning'
    },
    '2': {
        'text': 'Done',
        'class': 'bg-green',
        'restricted': true
    },
    '3': {
        'text': 'Redo',
        'class': 'bg-secondary'
    }
};